<template>
  <div class="page-wrapper">
    <div class="viewpage-caption-container clearFix">
      <div class="title">Sales Reports</div>
    </div>
    <el-tabs v-model="activeTabName" @tab-click="handleClick" type="border-card">
      <el-tab-pane name="first">
        <span slot="label">
          <i class="el-icon-document"></i> Inovices & Credit Notes Detail (2 Sublist)
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSetting :showDeliveryDate="false"/>
          <ReportProducts />
          <ReportCsr />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="second">
        <span slot="label">
          <i class="el-icon-notebook-2"></i> Customers Sales Summary
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSetting :showDateRangeRadio="false" :showSearchBy="false" />
          <ReportCsr />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="third">
        <span slot="label">
          <i class="el-icon-coin"></i> Slow-moving Products Analysis
        </span>
        <el-form ref="form" label-width="120px">
          <ReportBasicSettingSl />
          <ReportProducts />
          <div class="submit">
            <el-button type="primary" @click="handleSubmit" size="mini">Submit</el-button>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportBasicSetting from '../components/ReportBasicSetting'
import ReportProducts from '../components/ReportProducts'
import ReportCsr from '../components/ReportCsr'
import ReportBasicSettingSl from '../components/ReportBasicSettingSl'
import { mapActions } from 'vuex'

export default {
  name: 'reportSales',
  components: {
    ReportBasicSetting,
    ReportProducts,
    ReportCsr,
    ReportBasicSettingSl
  },
  created () {
    this.initInvDetails()
  },
  data () {
    return {
      storeName1: 'salesReportSearch1',
      storeName2: 'salesReportSearch2',
      storeName3: 'salesReportSearch3',
      activeTabName: 'first',
      tabsVifFlag: 1
    }
  },
  methods: {
    ...mapActions({
      initInvDetails: 'report/initInvDetails',
      initSaleSummary: 'report/initSaleSummary',
      initSlowMoving: 'report/initSlowMoving',
      queryInvoiceDetails: 'report/invoiceDetails'
    }),
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.tabsVifFlag = 1
        this.initInvDetails()
      } else if (tab.name === 'second') {
        this.tabsVifFlag = 2
        this.initSaleSummary()
      } else if (tab.name === 'third') {
        this.tabsVifFlag = 3
        this.initSlowMoving()
      }
    },
    async handleSubmit () {
      // todo
      await this.queryInvoiceDetails()
      this.$message({
        message: 'Preparing for the report, please check it later',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  text-align: left;
  max-width: 1660px;
}
.viewpage-caption-container {
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  float: left;
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.btn,
.btn-secondary {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.clearFix::after {
  content: '';
  display: block;
  height: 0;
  clear: both;
}
.submit {
  margin-top: 20px;
}
</style>
